exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-icon{display:inline-block;color:inherit;cursor:pointer;transition:opacity .3s}.customer-icon:hover{opacity:.7}.customer-icon .svg-container{display:inline-block;height:2rem;vertical-align:middle}.customer-icon .svg-container svg{height:100%}.customer-icon .customer-name{color:inherit;display:inline}.account-dropdown a{color:#000}", ""]);

// exports
